import * as React from "react";
const DeleteIcon = () => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.31141 2L5.69141 5.63"
      stroke="#292D32"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.6914 2L19.3114 5.63"
      stroke="#292D32"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 7.85156C2.5 6.00156 3.49 5.85156 4.72 5.85156H20.28C21.51 5.85156 22.5 6.00156 22.5 7.85156C22.5 10.0016 21.51 9.85156 20.28 9.85156H4.72C3.49 9.85156 2.5 10.0016 2.5 7.85156Z"
      stroke="#292D32"
      strokeWidth={1.5}
    />
    <path
      d="M10.2617 14V17.55"
      stroke="#292D32"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M14.8594 14V17.55"
      stroke="#292D32"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M5.41016 18.64C5.73016 20.58 6.50016 22 9.36016 22H15.3902C18.5002 22 18.9602 20.64 19.3202 18.76L21.0002 10"
      stroke="#292D32"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M4 10L4.72 14.38"
      stroke="#292D32"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);
export default DeleteIcon;
